/* Earthly Habit — global behaviors
   Cart drawer, mobile menu, search overlay, header scroll, accordion, qty stepper.
   Vanilla JS, deferred. No framework. */

(function () {
  'use strict';

  // ─── Header scroll behavior ────────────────────────────────────────────────
  const header = document.querySelector('.header');
  if (header) {
    let last = -1;
    const onScroll = () => {
      const y = window.scrollY;
      if (y === last) return;
      last = y;
      header.classList.toggle('is-scrolled', y > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ─── Body lock helper ──────────────────────────────────────────────────────
  const bodyLock = (lock) => document.body.classList.toggle('locked', lock);

  // ─── Drawer toggle helper ──────────────────────────────────────────────────
  function setupDrawer(triggerSel, openerOpts) {
    const triggers = document.querySelectorAll(triggerSel);
    triggers.forEach((t) => t.addEventListener('click', (e) => {
      e.preventDefault();
      openerOpts.open();
    }));
  }

  // ─── Cart drawer ───────────────────────────────────────────────────────────
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartBackdrop && cartBackdrop.classList.add('is-open');
    bodyLock(true);
  };
  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartBackdrop && cartBackdrop.classList.remove('is-open');
    bodyLock(false);
  };
  document.querySelectorAll('[data-cart-toggle]').forEach((b) =>
    b.addEventListener('click', (e) => { e.preventDefault(); openCart(); })
  );
  document.querySelectorAll('[data-cart-close]').forEach((b) =>
    b.addEventListener('click', closeCart)
  );
  cartBackdrop && cartBackdrop.addEventListener('click', closeCart);

  // Cart add via fetch
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    try {
      await fetch(window.Shopify.routes.cart_add_url, { method: 'POST', body: fd, headers: { Accept: 'application/javascript' } });
      await refreshCart();
      openCart();
    } catch (err) {
      console.error('cart add failed', err);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  async function refreshCart() {
    if (!cartDrawer) return;
    try {
      const res = await fetch(window.Shopify.routes.cart_url + '?section_id=cart-drawer');
      const text = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      const fresh = tmp.querySelector('[data-cart-drawer-body]');
      const target = cartDrawer.querySelector('[data-cart-drawer-body]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
      // Update bag count
      const meta = tmp.querySelector('[data-cart-count]');
      const bagCount = document.querySelectorAll('[data-cart-count]');
      if (meta) bagCount.forEach((b) => { b.textContent = meta.textContent; b.dataset.count = meta.dataset.count; });
    } catch (err) { console.error('refreshCart', err); }
  }

  // Cart line item qty change
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty, 10);
    await fetch(window.Shopify.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshCart();
  });
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    const key = rm.dataset.key;
    await fetch(window.Shopify.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await refreshCart();
  });

  // ─── Mobile menu drawer ────────────────────────────────────────────────────
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  document.querySelectorAll('[data-menu-toggle]').forEach((b) =>
    b.addEventListener('click', () => {
      menuDrawer && menuDrawer.classList.add('is-open');
      bodyLock(true);
    })
  );
  document.querySelectorAll('[data-menu-close]').forEach((b) =>
    b.addEventListener('click', () => {
      menuDrawer && menuDrawer.classList.remove('is-open');
      bodyLock(false);
    })
  );

  // ─── Search overlay ────────────────────────────────────────────────────────
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = searchOverlay && searchOverlay.querySelector('input[type="search"]');
  document.querySelectorAll('[data-search-toggle]').forEach((b) =>
    b.addEventListener('click', () => {
      searchOverlay && searchOverlay.classList.add('is-open');
      bodyLock(true);
      searchInput && setTimeout(() => searchInput.focus(), 250);
    })
  );
  document.querySelectorAll('[data-search-close]').forEach((b) =>
    b.addEventListener('click', () => {
      searchOverlay && searchOverlay.classList.remove('is-open');
      bodyLock(false);
    })
  );

  // ─── Esc to close drawers ──────────────────────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    if (menuDrawer && menuDrawer.classList.contains('is-open')) {
      menuDrawer.classList.remove('is-open');
      bodyLock(false);
    }
    if (searchOverlay && searchOverlay.classList.contains('is-open')) {
      searchOverlay.classList.remove('is-open');
      bodyLock(false);
    }
  });

  // ─── Accordion (FAQ + PDP) ─────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const head = e.target.closest('[data-acc-head]');
    if (!head) return;
    const item = head.closest('[data-acc-item]');
    if (!item) return;
    const open = item.classList.contains('is-open');
    // Single-open mode if container has [data-acc-single]
    const container = item.parentElement;
    if (container && container.hasAttribute('data-acc-single')) {
      container.querySelectorAll('.is-open').forEach((el) => el.classList.remove('is-open'));
    }
    item.classList.toggle('is-open', !open);
  });

  // ─── Quantity stepper ──────────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-stepper]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    const delta = parseInt(btn.dataset.qtyStepper, 10);
    const next = Math.max(parseInt(input.min || 1, 10), parseInt(input.value, 10) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ─── Subscribe/one-time toggle (PDP) ───────────────────────────────────────
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-po-option]');
    if (!opt) return;
    const group = opt.closest('[data-po-group]');
    if (!group) return;
    group.querySelectorAll('[data-po-option]').forEach((o) => o.classList.remove('is-active'));
    opt.classList.add('is-active');
    const sellingPlan = opt.dataset.sellingPlan || '';
    const form = group.closest('form');
    if (!form) return;
    let input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }
    input.value = sellingPlan;
  });

  // ─── Variant pills (PDP) ───────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('.variant-opt');
    if (!opt) return;
    const group = opt.closest('[data-variant-group]');
    if (!group) return;
    group.querySelectorAll('.variant-opt').forEach((o) => o.classList.remove('is-active'));
    opt.classList.add('is-active');
    // Trigger variant change event for product-form.js
    document.dispatchEvent(new CustomEvent('variant:change'));
  });

  // ─── Newsletter inline success ─────────────────────────────────────────────
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-newsletter]');
    if (!form) return;
    // Let it submit normally to Shopify customer endpoint; show success inline if hash returns
  });

  // ─── Announcement marquee duplication (for seamless loop) ──────────────────
  document.querySelectorAll('.marquee-track').forEach((track) => {
    if (track.dataset.loop === 'true') return;
    track.dataset.loop = 'true';
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  // ─── PDP gallery thumb selector ────────────────────────────────────────────
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-pdp-main]');
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt || '';
        if (main && src) {
          const img = main.querySelector('img');
          if (img) { img.src = src; img.alt = alt; }
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
})();
